import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import QueryForm from './QueryForm';
import FeaturedList from './FeaturedList';
import UpcomingList from './UpcomingList';
import ListPager from './ListPager';
import Loader from './Loader';
import { AJAX_URL } from '../../config/index.js';

export default function EventsList() {
  const [isLoading, setLoading] = useState(true);
  const [eventList, setEventList] = useState([]);
  const [featuredList, setFeaturedList] = useState([]);
  const [query, setQuery] = useState({
    keywords: '',
    region: '',
    type: '',
    startDate: '',
    endDate: ''
  });

  // Pagination State
  const [limit, setLimit] = useState(24);
  const [pagerIndex, setPagerIndex] = useState(0);
  const [paginatedEvents, setPaginatedEvents] = useState([]);
  const [paginatedFeatured, setPaginatedFeatured] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const handlePagination = (list, currentIndex, featured = false) => {
    !featured ? setTotalPages(Math.ceil(list.length / limit)) : '';
    const lastPage = totalPages - 1;

    if (!featured) {
      if (currentIndex >= totalPages) {
        setPagerIndex(0);
        return;
      } else if (currentIndex < 0) {
        setPagerIndex(lastPage);
        return;
      }
    }

    const startIndex = limit * currentIndex;
    const endIndex = startIndex + limit;
    const selection = list.slice(startIndex, endIndex);
    !featured ? setPaginatedEvents(selection) : setPaginatedFeatured(selection);
  };

  const prevPage = () => setPagerIndex(pagerIndex - 1);
  const nextPage = () => setPagerIndex(pagerIndex + 1);

  const filterAndSortEventData = (eventData) => {
    let filteredAndSortedEvents = eventData.filter(
      (i) => i.end_of_event >= new Date().getTime()
    );

    filteredAndSortedEvents = filteredAndSortedEvents.sort(
      (a, b) => new Date(b.full_date) - new Date(a.full_date)
    );

    setEventList(filteredAndSortedEvents.reverse());
  };

  useEffect(() => {
    let isSubscribed = true;

    setLoading(true);

    const fetchEvents = async (query) => {
      await $.ajax({
        type: 'POST',
        url: `${AJAX_URL}post_wl_query_featured_events`,
        dataType: 'json',
        encode: true,
        data: query,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => (isSubscribed ? filterAndSortEventData(res.data) : null))
        .catch((err) => console.log(err.message));
    };

    fetchEvents(query);

    return () => (isSubscribed = false);
  }, [query, limit]);

  const createFeaturedList = (list) => {
    let featuredList = [];

    for (const item of list) {
      item.active_featured === true ? featuredList.push(item) : '';
    }

    return featuredList;
  };

  useEffect(() => {
    const timeOut = setTimeout(() => setLoading(false), 2000);
    setFeaturedList(createFeaturedList(eventList));
    handlePagination(eventList, pagerIndex);

    return () => clearTimeout(timeOut);
  }, [eventList]);

  useEffect(() => {
    handlePagination(eventList, pagerIndex);
    handlePagination(featuredList, pagerIndex, true);
  }, [pagerIndex, featuredList, limit]);

  return (
    <div id="scroll-anchor">
      <QueryForm updateQuery={setQuery} query={query} />
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          {eventList.length === 0 ? (
            <NoResults />
          ) : (
            <div>
              <FeaturedList
                isLoading={isLoading}
                featuredEvents={paginatedFeatured}
              />

              <UpcomingList upcomingEvent={paginatedEvents} />
              <ListPager
                changeLimit={setLimit}
                limit={limit}
                setPagerIndex={setPagerIndex}
                nextPage={nextPage}
                prevPage={prevPage}
                pagerIndex={pagerIndex}
                totalEvents={eventList.length}
                totalPages={totalPages}
                paginatedItemCount={paginatedEvents.length}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function NoResults() {
  return (
    <section className="section">
      <div className="container container--xl">
        <div className="grid grid--std">
          <div className="grid__col-lg-8">
            <div className="section__header">
              <h4 className="section__header-text">Upcoming Events by Month</h4>
            </div>
            <div className="upcoming-events__list">
              I'm sorry no events were found matching that description.
            </div>
          </div>
          <div className="grid__col-lg-4"></div>
        </div>
        <div className="line-break__hr"></div>
      </div>
    </section>
  );
}
